export default {
  sm: `
    자연과 함께 만드는
    에너지 효율
  `,
  xxl: `
    자연과 함께
    만드는
    에너지 효율
  `
};
